import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
} from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import Snackbar from '../../../Components/Snackbar';
import { helpers } from "../../../helpers";
import Services from '../../../Services';
import DynamicFormFieldsAntd from "../../../Components/InputComponents/DynamicFormFIeldsAntd";
import { Form, message } from "antd";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useStaticState } from "@material-ui/pickers";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";

const {
  employee,
  Storage
} = Services;

const {
  showSnackBar,
} = helpers;


const CreateTicket = () => {
  //loader states
  const storage = new Storage()
  const [equipment, setEquipment] = useState([])
  const [isRequestType, setIsRequestType] = useState(0)
  const [form] = Form.useForm()
  const location = useLocation()
  const [uploadedFiles, setUploadedFiles] = useState([])


  //list state
  const [lists, setLists] = useState({
    employees: [],
    types: [],
    categories: []
  })

  //data states
  const [ticketData, setTicketData] = useState({
    requestedBy: '',
    requestedFor: '',
    requestedType: '',
    category: '',
    comments: '',
    alert: false,
  })

  const validTypes = ['image/png', 'image/jpeg', 'image/JPEG', 'image/PNG', 'image/JPG', 'image/jpg', 'application/msword', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']

  const clearUplaodedFiles = () => setUploadedFiles([]);

  const setEmployeeAndTypeList = async (categories) => {
    let employeeList = await employee.get_employee_listing()
    if (employeeList.httpStatus == 200) {
      employeeList = employeeList.data;
      employeeList.map(row => {
        row.name = `${row.firstName} ${row.lastName}`
      })
    }
    let typeList = await employee.get_ticket_type_listing()
    if (typeList.httpStatus == 200) {
      typeList = typeList.data
    }
    setLists({ employees: employeeList, types: typeList, categories: categories ? categories : [] })
    return true
  }

  const setCategoryList = async (id) => {
    let categoryList = await employee.get_ticket_category_by_type({ id })
    if (categoryList.httpStatus == 200) {
      categoryList = categoryList.data
      setLists({ ...lists, categories: categoryList })
      return categoryList
    }
    return true
  }

  const fetchData = async () => {
    let apis = [
      employee.get_locomotive_equip_Status()
    ]
    let [res1] = await Promise.all(apis)
    setEquipment(res1?.data)
  }

  const handleRequestType = (value) => {
    form.setFieldsValue({
      category: undefined
    })
    setIsRequestType(value)
    setCategoryList(value)
    if (value === 4) {
      fetchData()
    }
  }

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  const prepareFilesForApi = async () => {
    const filesArray = await Promise.all(
      uploadedFiles.map(async (file, index) => {
        const base64String = await fileToBase64(file);
        return {
          name: file.name,
          file: base64String,
        };
      })
    );
    return filesArray;
  };


  const onFinish = async (values) => {

    let user = JSON.parse(storage.get('user_profile'))
    const filesForApi = await prepareFilesForApi();

    let body = {
      for: values?.requestFor,
      by: user?.id,
      type: (values?.requestType),
      category: values?.category,
      comment: !values?.comment ? "" : values?.comment,
      alert: false,
      location: equipment.filter(x => x?.id === values?.equipmentId)[0]?.TGSLocation?.id,
      equipId: (values?.equipmentId),
      attachments: filesForApi,
      request_type: isRequestType
    }

    if (values?.requestFor === user?.firstName + " " + user?.lastName) body.for = user?.id

    Object.entries(body).forEach(([key, value]) => {
      if (key === "location" && value === null) body[key] = undefined
      if (key !== 'location')
        if ([undefined, null].includes(value))
          delete body[key]
    })
    let result = await employee.create_ticket({ ...body })
    if (result?.httpStatus === 200) {
      showSnackBar('Form Successfully Submitted')
      form.setFieldsValue({
        requestFor: user.firstName + " " + user?.lastName,
        requestType: undefined,
        category: undefined,
        comment: "",
        alert: false,
        location: undefined,
        equipmentId: undefined
      })
      setIsRequestType(0)
      setUploadedFiles([])
    }
  }

  let fields = [
    { isRequired: true, isDisabled: true, type: 1, label: "Request By", keyName: 'requestBy' },
    { isRequired: true, type: 3, label: "Request For", options: lists?.employees?.map(x => { return { id: x?.id, title: `${x?.firstName} ${x?.lastName}` } }) || [], keyName: "requestFor", key: "id" },
    { isRequired: true, type: 3, label: "Request Type", options: lists?.types?.map(x => { return { id: x?.id, title: x?.name } }) || [], keyName: "requestType", onChange: handleRequestType },
    { type: 5, label: "Comments", keyName: "comment", rows: 8, page: "createTicket" },
    { isRequired: true, isDisabled: isRequestType === 0 ? true : false, type: 3, label: "Category", options: lists?.categories?.map(x => { return { id: x?.id, title: x?.name } }) || [], keyName: "category" },
    { isRequired: true, isDisabled: false, type: isRequestType === 4 ? 3 : 9, label: "Equipment ID", options: equipment?.map(x => { return { id: x?.id, title: x?.EquipUID } }) || [], keyName: "equipmentId" },
  ]

  useEffect(async () => {
    let categories = []
    if (location?.state) {
      let {
        EquipId,
        type
      } = location?.state;
      form.setFieldsValue({
        equipmentId: EquipId,
        requestType: type,
      })
      setIsRequestType(type)
      fetchData()
      categories = await setCategoryList(type)
    }

    let user = JSON.parse(storage.get('user_profile'))
    form.setFieldsValue({
      requestBy: user?.firstName + " " + user?.lastName,
      requestFor: user?.firstName + " " + user?.lastName
    })
    setTicketData({ ...ticketData, requestedBy: user, requestedFor: { ...user, name: user.firstName + " " + user?.lastName } })
    if (user) {
      setEmployeeAndTypeList(categories)
    }
  }, [])

  const removeFile = (fileIndexToOptOut) => {
    const files = Array.from(uploadedFiles).filter(
      (files, fileIndex) => fileIndex !== fileIndexToOptOut
    );
    setUploadedFiles(files);

  };

  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items;
    const files = [];
    for (let i = 0; i < clipboardItems.length; i++) {
      const item = clipboardItems[i];
      if (item.type.includes("image")) {
        const file = item.getAsFile();
        files.push(file);
      }
    }
    if (files.length) {
      setUploadedFiles((prevFiles) => [...prevFiles, ...files]);
    }
  };

  useEffect(() => {
    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, []);

  return (
    <PageLayout>
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Create a Ticket </Grid>
        {/* Page Start */}
        <div className="antd-form">
          <Form form={form} onFinish={onFinish} onFinishFailed={(err) => { }}>
            <div
              style={{
                width: '100%',
                marginTop: "50px",
                display: "grid",
                gridTemplateColumns: "auto auto",
                gap: "10px",
                alignItems: "flex-start"
              }} >
              <DynamicFormFieldsAntd fields={fields} form={form} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", }}>
              <Grid xs={12} className={`mbold`} style={{ marginBottom: '10px', fontWeight: '800' }}>Upload Documents</Grid>
              {!uploadedFiles.length
                ? (
                  <Grid xs={12}>
                    <Grid xs={12} id="Step2DragFile" className="Step2DragFile mt14">
                      <div style={{ display: "flex", flexDirection: "column", gap: "10px", }}>
                        <Button
                          style={{ background: "lightgray", width: "130px" }}
                          onClick={($event) => {
                            const input = document.getElementById('additional-files-input');
                            input.click();
                          }}>Upload / Paste</Button>
                        <span style={{ fontSize: "10px", color: "darkGray" }}>Acceptable formats (JPG, PNG, Word, PDF)</span>
                      </div>
                    </Grid>
                    <input
                      id="additional-files-input"
                      type="file"
                      multiple="multiple"
                      hidden="true"
                      onChange={($event) => {
                        let validImages = []
                        Object.values($event.target.files)?.forEach(x => {
                          if (!validTypes.includes(x?.type)) { message?.destroy(); return message.error("Unacceptable format!") }
                          if (x?.size / 1024 > (5 * 1024)) { message?.destroy(); return message.error("Max file size should be less than 5mb") }
                          validImages.push(x)
                        })
                        setUploadedFiles(validImages);
                      }}
                    />
                  </Grid>)
                :
                (<div style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%" }}>
                  {Array
                    .from(uploadedFiles)
                    .map(
                      (file, fileIndex) => (
                        <Grid className="upload-files-tag  position-relative">
                          <Grid className="d-flex justify-content-end position-absolute r-0">
                            <Button
                              className="dustbinBtn min-width-auto dustbinBtn-size-auto-100"
                              onClick={
                                $e => {
                                  removeFile(fileIndex)
                                }
                              }></Button>
                          </Grid>
                          <p className="attatchmentTag">
                            {file.name}
                          </p>
                        </Grid>))}
                  <Grid xs={12} className="mt12 pr70">
                    <Grid xs={12} container >
                      {
                        uploadedFiles?.length ? <span
                          onClick={clearUplaodedFiles}
                          className="upload-btn"
                          style={{ padding: '1px' }}>
                          Clear All
                        </span> : <></>}
                    </Grid>
                  </Grid>
                </div>)}
            </div>
            <Grid xs={12} container className="mt50" justifyContent="flex-end">
              <Button type="submit" className="LinkButton" >Submit</Button>
            </Grid>
          </Form>
        </div>
        <Snackbar></Snackbar>
        {/* Page Start End */}
      </Grid>
    </PageLayout>
  );
}

export default CreateTicket;